const C = require("../constants");

const sectionDialog = (data) => {
    return {
        type: C.SECTION_DIALOG,
        data
    }
};

export {sectionDialog};


// WEBPACK FOOTER //
// ./src/actions/SectionDialogAction.js